import React, { Fragment } from "react";

export default (
  <>
    <path d="M3 12c4.5 6.667 13.5 6.667 18 0-4.5-6.667-13.5-6.667-18 0zm18.829.56c-4.897 7.254-14.761 7.254-19.658 0a1 1 0 0 1 0-1.12c4.897-7.254 14.761-7.254 19.658 0a1 1 0 0 1 0 1.12z" />
    <path d="M12 15.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
  </>
);
